import axios from "axios";
import { ExternalLink } from "lucide-react";
import { withUtm } from "@/data/partners";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PartnerCard({ item, category, stepN }) {
  const href = withUtm(item.url, { campaign: stepN ? `step-${stepN}` : category, content: item.id });
  const track = () => {
    axios.post(`${API}/partners/click`, { partner_id: item.id, name: item.name, category }).catch(() => {});
  };
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer sponsored"
      onClick={track}
      data-testid={`partner-${item.id}`}
      className="group block border border-slate-200 rounded-md p-4 hover:border-brand transition-colors"
    >
      <div className="flex items-start justify-between gap-3">
        <span className="font-semibold text-slate-900 text-sm leading-snug">{item.name}</span>
        <ExternalLink className="w-4 h-4 text-slate-300 group-hover:text-brand shrink-0 transition-colors" />
      </div>
      <p className="text-xs text-slate-500 mt-1 leading-relaxed">{item.desc}</p>
      <span className="inline-block mt-2 text-[10px] tracking-[0.15em] uppercase font-bold text-brand bg-orange-50 rounded px-1.5 py-0.5">
        Partner
      </span>
    </a>
  );
}
